import { LoadingButton } from "@mui/lab";
import { Tooltip } from "@mui/material";
import React from 'react';
import { tooltipColour } from "../BEE123.Constants";

interface IProps {
  buttonText: string;
  tooltipTitle: string;
  form?: string;
  disabled: boolean;
  isLoading: boolean;
  showTooltipOnDisabled: boolean;
  onClick?: () => void;
  position?: "right" | "left";
  marginRight?: string;
  ref?: React.Ref<HTMLButtonElement>;
}

export const TooltipLoadingButton = React.forwardRef<HTMLButtonElement, IProps>(({
  buttonText,
  tooltipTitle,
  form,
  disabled,
  isLoading,
  showTooltipOnDisabled,
  position,
  onClick,
  marginRight
}, ref) => {
  return (
    <Tooltip
      title={showTooltipOnDisabled && disabled ? tooltipTitle : ""}
      arrow
      PopperProps={{
        placement: position,
        style: { zIndex: 9999 },
      }}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: tooltipColour,
            '& .MuiTooltip-arrow': {
              color: tooltipColour
            },
          },
        },
      }}>
      <LoadingButton
        ref={ref} // Forward the ref to the underlying button
        loading={isLoading}
        variant="contained"
        form={form}
        color="primary"
        type="submit"
        disabled={disabled}
        onClick={onClick}
        style={{ marginRight: marginRight ? parseInt(marginRight) : 0 }}
        sx={{
          '&:focus': {
            outline: 'none',
            boxShadow: '0 0 0 3px rgba(0, 123, 255, 0.5)',
          },
        }}
      >
        {buttonText}
      </LoadingButton>
    </Tooltip>
  );
});